export const EMPTY_SORT_INSTEAD_ZERO_VALUE = 6;

export enum SortingTypeIndexPeople {
  surnameAsc = 0,
  surnameDesc = 1,
  nameAsc = 2,
  nameDesc = 3,
  opa = 4,
}

export function sortByRuSurname<T>(items: T[], getSurname: (item: T) => string | undefined): T[] {
  if (!items?.length) {
    return items || [];
  }
  return [...items].sort((a, b) => {
    const surA = (getSurname(a) || '').trim();
    const surB = (getSurname(b) || '').trim();
    if (!surA && !surB) return 0;
    if (!surA) return 1;
    if (!surB) return -1;
    return surA.localeCompare(surB, 'ru');
  });
}
export const EMPTY_SORT_INSTEAD_ZERO_VALUE = 6;

export enum SortingTypeIndexPeople {
  surnameAsc = 0,
  surnameDesc = 1,
  nameAsc = 2,
  nameDesc = 3,
  opa = 4,
}

export function sortByRuSurname<T>(items: T[], getSurname: (item: T) => string | undefined): T[] {
  if (!items?.length) {
    return items || [];
  }
  return [...items].sort((a, b) => {
    const surA = (getSurname(a) || '').trim();
    const surB = (getSurname(b) || '').trim();
    if (!surA && !surB) return 0;
    if (!surA) return 1;
    if (!surB) return -1;
    return surA.localeCompare(surB, 'ru');
  });
}
